import {EventBus} from '@/common/helpers/utils/EventBus';
import {appClientVersionMetaParser, appClientVersionNumberParser} from './appClientVersionParser';

export class RemoteRefresh {
	waitingToRefresh = false;

	private currentVersion: null | number = null;

	onRefreshRequired = new EventBus<void>();

	/**
	 * Check is new client version in not differ from the current if it is - initialize deferred page refresh
	 */
	checkClientVersion(clientVersionString: string) {
		const versionNumber = appClientVersionNumberParser(clientVersionString);
		if (versionNumber === null) {
			return;
		}

		if (this.currentVersion === null || this.currentVersion === versionNumber) {
			this.currentVersion = versionNumber;
			return;
		}

		this.currentVersion = versionNumber;
		const updateMeta = appClientVersionMetaParser(clientVersionString);
		if (!updateMeta) {
			console.error('Error has occurred when trying to update client version: meta params is invalid');
			return;
		}

		const {jitterMin, jitterMax} = updateMeta;
		const jitter = Math.floor(Math.random() * (jitterMax - jitterMin + 1) + jitterMin);
		setTimeout(() => {
			this.initializePageRefresh(updateMeta);
		}, jitter);
	}

	/**
	 * Start deferred page refresh
	 */
	private initializePageRefresh(params: {inactivityInterval: number; maxInterval: number; updateTime: number}) {
		this.waitingToRefresh = true;
		this.onRefreshRequired.emit();

		// Update immediate when maxInterval is the past, refresh immediately
		const nowTime = new Date().getTime();

		if (params.maxInterval && nowTime - params.updateTime > params.maxInterval) {
			window.location.reload();
			return;
		}

		let refreshByInactivityTimeout = 0;
		const startRefreshByInactivity = () => {
			clearTimeout(refreshByInactivityTimeout);
			refreshByInactivityTimeout = window.setTimeout(() => {
				window.location.reload();
			}, params.inactivityInterval);
		};

		// Start to update by inactivity and restart in on any user activity
		startRefreshByInactivity();
		window.addEventListener('focus', startRefreshByInactivity);
		window.addEventListener('keydown', startRefreshByInactivity, {passive: true});
		window.addEventListener('mousedown', startRefreshByInactivity, {passive: true});

		let previousPointerPosition: number[] = [];
		window.addEventListener(
			'mousemove',
			event => {
				// Ignore move event without pointer coordinates change... yes it happens
				const pointerPosition = [event.clientX, event.clientY];
				if (
					previousPointerPosition[0] !== pointerPosition[0] ||
					previousPointerPosition[1] !== pointerPosition[1]
				) {
					startRefreshByInactivity();
				}
				previousPointerPosition = pointerPosition;
			},
			{passive: true},
		);

		// Refresh in a max interval
		setTimeout(() => {
			window.location.reload();
		}, params.maxInterval);
	}
}
